export class GerarDanfeRequest {
  nomeXml: string = '';
  caminhoGcs?: string;
  isDocumentoRecebido: boolean = false;
}
